import { ElementType } from "react";
import {
	CommonPropertyProps,
	ElementSchema,
	ElementTypeList,
	PayloadRules,
	Payload,
} from "schemas/elements";
import elementsSchema from "schemas";
import { PayloadMap } from "../properties";
import { v4 as uuidv4 } from "uuid";
import { IdData } from "hooks/FormDesigner/useElementList";
import { AlertProps } from "@alm/flow-ds/components";

type payloadProps = "filter" | "sort" | "page-size" | "request-uri";

type payloadPropertyTypes = "filter" | "sort" | "number" | "entity";

type Props = Omit<CommonPropertyProps, "value"> & {
	elem: string;
	value: Payload;
	addAlert: (alert: string, status: AlertProps["status"]) => void;
	nestedField: "search";
	idList: IdData;
	loading: boolean;
	disabledPlaceholder: string;
};

export default ({
	updateStore,
	field,
	required,
	value = { filter: [], sort: [], "page-size": 10 },
	// desc,
	validation,
	elementIndex,
	elem,
	addAlert,
	nestedField,
	idList,
	loading,
	disabledPlaceholder,
}: Props) => {
	const props = {
		updateStore,
		field,
		required,
		elementIndex,
		validation,
		value: { ...value },
		nestedField,
	};
	const myElementSchema: ElementSchema = elementsSchema as ElementSchema;

	// looks for the element in the schema to get the props it needs for later
	const payloadElement: PayloadRules =
		myElementSchema[elem as ElementTypeList].search.rules.payload.rules;

	return (
		<>
			{Object.keys(payloadElement).map(property => {
				const theProperty = property as payloadProps;
				if (theProperty !== "request-uri") {
					const theObject = payloadElement[theProperty];
					const Property: ElementType =
						PayloadMap[theObject.type as payloadPropertyTypes];
					const id: string = uuidv4();
					const addedProps = {
						...props,
						options: idList,
						loading,
						disabledPlaceholder,
					};

					return (
						<Property
							key={theProperty}
							{...(theProperty === "sort" ? addedProps : props)}
							id={id}
							nextProp={property}
							desc={theObject?.desc}
							required={theObject?.required}
							addAlert={addAlert}
						/>
					);
				}
				return false;
			})}
		</>
	);
};
